import { forwardRef } from 'react';
import styled from 'styled-components';

import TextPrompt from '../text-prompt';

interface IInput extends React.ComponentPropsWithoutRef<'input'> {
	label?: string;
	error?: string | undefined;
	children?: any;
}

// eslint-disable-next-line react/display-name
export const TypeCheckbox = forwardRef(({ label, error, children, ...props }: IInput, ref) => (
	<TypeCheckBoxStyle>
		<div className='form-container'>
			{label && <label htmlFor={props.id || props.name}>{label}</label>}
			<div className='checkbox-content'>
				<input
					onChange={() => {}}
					{...props}
					ref={ref as React.LegacyRef<HTMLInputElement> | undefined}
					type='checkbox'
				/>
				{children}
			</div>
			{!!error && (
				<TextPrompt
					prompt={error}
					status={false}
				/>
			)}
		</div>
	</TypeCheckBoxStyle>
));

const TypeCheckBoxStyle = styled.div`
	label {
		color: var(--text-primary, #235a62);
		font-size: 0.875rem;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		margin: 0 0 0.81rem;
	}
	.checkbox-content {
		display: flex;
		align-items: center;
		input {
			outline-color: var(--border-input, #dbeaff);
			border-radius: 3px;
			height: 14px;
			width: 14px;
			background: none;
			border: 1px solid var(--border-input, #a1a1a1);
			accent-color: var(--color-primary, #1b6b4a);
		}
	}
`;
